import { inject, Injectable, OnDestroy } from '@angular/core';
import {
  SidebarProduction,
  sidebarShipHawk,
} from 'src/app/settings/nav-list/recursive-sidebar/data/sideBarData';

import { Subject } from 'rxjs';
import {
  SideBar,
  SideBarButton,
} from 'src/app/settings/nav-list/recursive-sidebar/class/sidebar';
import { SearchService } from '../search/search.service';

@Injectable({
  providedIn: 'root',
})
export class SidebarService implements OnDestroy {
  searchService = inject(SearchService);
  sidebar = new SideBar(
    [SidebarProduction, sidebarShipHawk],
    SidebarProduction,
    SidebarProduction.data,
    false
  );
  private sidenavToggleSubject = new Subject<void>();
  sidenavToggle$ = this.sidenavToggleSubject.asObservable();
  constructor() {}

  ngOnDestroy(): void {
    this.sidenavToggleSubject.complete();
  }

  cargarRutas(url: string): void {
    this.sidebar.ButonsData.forEach((button) => {
      this.RecursiveSecuence(button, url);
    });
  }
  obtenerRutasPermitidas(userRoles: string[]): void {
    this.getAllowedSideNavItems(userRoles);
  }
  reestructurarDepartamentos(): void {
    this.restructureDepartmentsGroup(this.sidebar);
    this.searchService.cargarSidebarRoutes(this.sidebar.ButonsData);
  }
  toggleSidebar(): void {
    this.sidenavToggleSubject.next();
  }
  RecursiveSecuence(button: SideBarButton, url: string): void {
    if (button.options.level === 3) {
      button.data.active = false;
    }
    if (button.butons) {
      button.butons.forEach((data) => {
        this.RecursiveSecuence(data, url);
      });
    }

    if (button.options.level === 1) {
      button.butons.forEach((buton) => {
        buton.data.active = this.isListActive(buton, url);
      });
    }
  }

  // Cargar rutas Comienzo
  private isListActive(button: SideBarButton, url: string): boolean {
    const { listOfUrls, listOfOtherUrls, listOfUniqueUrls } =
      this.getArrayOfPossibleUrls(button);
    const modifyAndResult = (
      listToLookFor: string[],
      urlToMatch: string,
      modify = true
    ) => {
      let url = listToLookFor.find((u) => urlToMatch === u);
      const splitUrl = urlToMatch.split('/');
      if (!url) {
        url = listToLookFor.find((u) => {
          const splitU = u.split('/');
          return splitU.every(
            (s, index) => s === splitUrl[index] || s.includes(':')
          );
        });
      }
      if (modify) {
        this.recursiveSearch(button, url);
      }

      return !!url;
    };
    if (button.data.url) {
      listOfUrls.push(button.data.url);
    }
    if (listOfOtherUrls.length > 0) {
      if (modifyAndResult(listOfOtherUrls, url)) {
        return true;
      }
    }
    const res = modifyAndResult([...listOfUniqueUrls], url);
    if (res) {
      return true;
    }

    return modifyAndResult([...listOfUrls], url, false);
  }
  private getArrayOfPossibleUrls(button: SideBarButton): {
    listOfOtherUrls: string[];
    listOfUniqueUrls: string[];
    listOfUrls: string[];
  } {
    const listOfOtherUrls: string[] = [];
    const listOfUniqueUrls: string[] = [];
    const listOfUrls: string[] = [];
    if (button.data.appendUrl) {
      this.RecursiveGetArrayPosibleUrls(
        button,
        listOfOtherUrls,
        listOfUniqueUrls,
        listOfUrls,
        button.data.appendUrl
      );
    } else {
      this.RecursiveGetArrayPosibleUrls(
        button,
        listOfOtherUrls,
        listOfUniqueUrls,
        listOfUrls
      );
    }

    return {
      listOfOtherUrls,
      listOfUniqueUrls,
      listOfUrls,
    };
  }
  private RecursiveGetArrayPosibleUrls(
    button: SideBarButton,
    listOfOtherUrls: string[],
    listOfUniqueUrls: string[],
    listOfUrls: string[],
    appendURL?: string
  ): void {
    if (appendURL) {
      if (button.data.overWriteUrl) {
        listOfUrls.push(
          ...this.modifyAndInsertArray([button.data.overWriteUrl])
        );
      } else if (button.data.url) {
        const finalUrl = appendURL + button.data.url;
        listOfUrls.push(...this.modifyAndInsertArray([finalUrl]));
      }

      if (button.data.otherUrls) {
        listOfOtherUrls.push(
          ...this.modifyAndInsertArray(button.data.otherUrls, appendURL)
        );
      }
      if (button.data.otherUniqueUrls) {
        listOfUniqueUrls.push(
          ...this.modifyAndInsertArray(button.data.otherUniqueUrls, appendURL)
        );
      }
    } else {
      if (button.data.url) {
        const finalUrl = button.data.overWriteUrl ?? button.data.url;
        listOfUrls.push(...this.modifyAndInsertArray([finalUrl]));
      }
      if (button.data.otherUrls) {
        listOfOtherUrls.push(
          ...this.modifyAndInsertArray(button.data.otherUrls)
        );
      }
      if (button.data.otherUniqueUrls) {
        listOfUniqueUrls.push(
          ...this.modifyAndInsertArray(button.data.otherUniqueUrls)
        );
      }
    }
    if (button.butons) {
      if (button.data.appendUrl) {
        button.butons.forEach((buton) => {
          this.RecursiveGetArrayPosibleUrls(
            buton,
            listOfOtherUrls,
            listOfUniqueUrls,
            listOfUrls,
            appendURL
          );
        });
      } else {
        button.butons.forEach((buton) => {
          this.RecursiveGetArrayPosibleUrls(
            buton,
            listOfOtherUrls,
            listOfUniqueUrls,
            listOfUrls
          );
        });
      }
    }
  }
  private modifyAndInsertArray(listToChange: string[], append = ''): string[] {
    return listToChange.map((url) => '/sb' + (append + url).replace('.', ''));
  }

  private recursiveSearch(button: SideBarButton, url: string): void {
    if (!url) {
      return;
    }

    const getRelativePath = (fullPath: string): string => {
      const segments = fullPath.split('/').filter(Boolean);
      // Tomamos los últimos 2 o más elementos para considerar /recurso/:param
      const index = segments.findIndex((s) => s.startsWith(':'));
      return index > 0
        ? segments.slice(index - 1).join('/')
        : segments.slice(-2).join('/'); // fallback si no hay parámetros
    };

    const relativeUrl = getRelativePath(url);

    if (button.butons) {
      for (const child of button.butons) {
        const urls = [
          ...(child.data.otherUrls ?? []),
          ...(child.data.otherUniqueUrls ?? []),
        ].filter((u): u is string => typeof u === 'string');

        const match = urls.find((u) => {
          const relativeChildUrl = getRelativePath(u);
          return relativeUrl === relativeChildUrl;
        });

        if (match) {
          child.data.active = true;
        }

        this.recursiveSearch(child, url); // sigue buscando hijos
      }
    }
  }
  // Cargar rutas fin

  // Obtener rutas permitidas Inicio
  getAllowedSideNavItems(userRoles: string[]): void {
    if (!userRoles.includes('ShipHawk')) {
      this.sidebar.SideBars = this.sidebar.SideBars.filter(
        (nav) => nav.name !== 'ShipHawk'
      );
    } else if (
      userRoles.length === 1 ||
      this.sidebar.ActiveSidebar.name === 'ShipHawk'
    ) {
      if (userRoles.length === 1) {
        this.sidebar.SideBars = this.sidebar.SideBars.filter(
          (nav) => nav.name === 'ShipHawk'
        );
      }
      this.sidebar.ActiveSidebar = sidebarShipHawk;
      this.sidebar.ButonsData = sidebarShipHawk.data;
      return;
    }
    this.sidebar.ButonsData = this.sidebar.ButonsData.map((group) => {
      return {
        ...group,
        butons: group.butons
          .map((button) => this.filterSidebarByRoles(button, userRoles))
          .filter((b): b is SideBarButton => !!b),
      };
    });
  }
  filterSidebarByRoles(
    node: SideBarButton,
    userRoles: string[]
  ): SideBarButton | undefined {
    const { roles, avoidRoles = [] } = node.data;
    const hasAccess = !roles || roles.some((role) => userRoles.includes(role));
    const hasAvoidAccess = avoidRoles.some((role) => userRoles.includes(role));
    if (!hasAccess || hasAvoidAccess) {
      return undefined;
    }

    let filteredChildren: SideBarButton[] | undefined;
    if (node.butons && node.butons.length > 0) {
      filteredChildren = node.butons
        .map((child) => this.filterSidebarByRoles(child, userRoles))
        .filter((c): c is SideBarButton => !!c);
    }

    return {
      ...node,
      butons: filteredChildren?.length ? filteredChildren : undefined,
    };
  }
  // Obtener rutas permitidas fin
  // Restructurar Departamentos comienzo
  restructureDepartmentsGroup(sideBar: SideBar): void {
    sideBar.ButonsData = sideBar.ButonsData.filter((g) => g.butons.length > 0);

    sideBar.ButonsData = this.restructureButtons(sideBar.ButonsData);

    sideBar.ButonsData = this.restructureDepartmentsAsButtons(
      sideBar.ButonsData
    );
  }

  restructureButtons(buttons: SideBarButton[]): SideBarButton[] {
    return buttons.map((btn) => {
      if (!btn.butons || btn.butons.length === 0) {
        return btn;
      }

      if (btn.butons.length === 1 && btn.butons[0].butons?.length > 1) {
        const inner = btn.butons[0];

        const flattened: SideBarButton[] = inner.butons.map((child) => ({
          data: {
            name: child.data.name,
            url: child.data.overWriteUrl
              ? child.data.overWriteUrl.replace('./', '/')
              : (inner.data.appendUrl?.replace('./', '/') ?? '') +
                child.data.url,
          },
          options: child.options,
          icon: child.icon,
        }));

        return {
          data: {
            ...btn.data,
            name: `${btn.data.name} - ${inner.data.name}`,
          },
          options: btn.options,
          icon: btn.icon,
          butons: flattened,
        };
      }

      return {
        ...btn,
        butons: this.restructureButtons(btn.butons),
      };
    });
  }
  restructureDepartmentsAsButtons(buttons: SideBarButton[]): SideBarButton[] {
    const result: SideBarButton[] = [];

    for (const btn of buttons) {
      if (btn.data.name !== 'Departamentos') {
        const restructured = {
          ...btn,
          butons: btn.butons
            ? this.restructureDepartmentsAsButtons(btn.butons)
            : undefined,
        };
        result.push(restructured);
        continue;
      }

      if (!btn.butons || btn.butons.length > 3) {
        result.push(btn);
        continue;
      }

      for (const list of btn.butons) {
        if (list.butons && list.butons.length > 0) {
          const flattenedChildren: SideBarButton[] = list.butons.map(
            (item) => ({
              data: {
                name: item.data.name,
                url: item.data.overWriteUrl
                  ? item.data.overWriteUrl.replace('./', '/')
                  : (list.data.appendUrl?.replace('./', '/') ?? '') +
                    item.data.url,
              },
              options: item.options,
              icon: item.icon,
            })
          );

          result.push({
            data: {
              name: list.data.name,
            },
            options: list.options,
            icon: list.icon,
            butons: flattenedChildren,
          });
        } else {
          result.push({
            data: {
              name: list.data.name,
              url: list.data.url,
            },
            options: list.options,
            icon: list.icon,
          });
        }
      }
    }

    return result;
  }
  // Restrucuturar departamentos fin
}
